(function () {
  var root = document.querySelector('.nb');
  if (!root) return;

  var gal = root.querySelector('[data-gal]');
  if (gal) {
    var tr = gal.querySelector('[data-track]');
    var dots = gal.querySelectorAll('.nb-gal__dots i');
    var th = gal.querySelectorAll('[data-go]');
    var cur = 0;
    function mark(i) {
      cur = i;
      dots.forEach(function (d, k) { d.classList.toggle('on', k === i); });
      th.forEach(function (b, k) { b.classList.toggle('on', k === i); });
    }
    if (tr) tr.addEventListener('scroll', function () {
      var i = Math.round(tr.scrollLeft / tr.clientWidth);
      if (i !== cur) mark(i);
    }, { passive: true });
    th.forEach(function (b) {
      b.addEventListener('click', function () {
        var i = +b.dataset.go;
        tr.scrollTo({ left: i * tr.clientWidth, behavior: 'smooth' });
        mark(i);
      });
    });
  }

  var form = root.querySelector('[data-nb-form]');
  if (form) {
    var idIn = form.querySelector('[name=id]');
    var btn = form.querySelector('[data-atc]');
    function sync() {
      var c = root.querySelector('[name=nb-tier]:checked');
      if (c) idIn.value = c.value;
    }
    root.querySelectorAll('[name=nb-tier]').forEach(function (r) { r.addEventListener('change', sync); });
    sync();
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var label = btn.textContent;
      btn.disabled = true; btn.textContent = 'Ajout en cours…';
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: +idIn.value, quantity: 1 }] }) })
        .then(function (r) { if (!r.ok) throw r; window.location.href = '/cart'; })
        .catch(function () { btn.disabled = false; btn.textContent = label; alert("Impossible d'ajouter le produit. Veuillez réessayer."); });
    });
  }

  root.querySelectorAll('[data-top]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      e.preventDefault();
      root.querySelector('.nb-info').scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });

  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (en) {
        if (!en.isIntersecting) return;
        en.target.classList.add('in');
        io.unobserve(en.target);
      });
    }, { rootMargin: '200px' });
    root.querySelectorAll('.nb-reveal').forEach(function (el) { io.observe(el); });
  } else {
    root.querySelectorAll('.nb-reveal').forEach(function (el) { el.classList.add('in'); });
  }
})();
